@if (isLoading()) {
  <div class="table" role="status" aria-label="Carregando histórico" [appSkeleton]="true">
    <div class="table-scroll">
      <div class="table-row table-head" role="row">
        <span>Alerta</span>
        <span>Resumo</span>
        <span>Data</span>
      </div>
      <div class="table-body">
        @for (row of skeletonRows; track row) {
          <div class="table-row" aria-hidden="true">
            <span class="cell-text cell-strong">Nome do alerta</span>
            <span class="cell-text">Resumo do alarme</span>
            <span class="cell-text">01/01/2026 12:00</span>
          </div>
        }
      </div>
    </div>
  </div>
} @else if (!alarms().length) {
  <empty-state
    title="Nenhum alarme no histórico"
    description="Quando um alerta disparar, o registro aparece aqui.">
  </empty-state>
} @else {
  <div class="table" role="table">
    <div class="table-scroll">
      <div class="table-row table-head" role="row">
        <span>Alerta</span>
        <span>Resumo</span>
        <span>Data</span>
      </div>
      <div class="table-body">
        @for (alarm of alarms(); track alarm._id) {
          <div class="table-row" role="row">
            <span
              class="cell-text cell-strong"
              [matTooltip]="alarm.alert_name"
              matTooltipPosition="above"
              matTooltipClass="induxtry-tooltip"
              #alertTip="matTooltip"
              (mouseenter)="syncCellTooltip($event, alertTip)">
              {{ alarm.alert_name }}
            </span>
            <span
              class="cell-text"
              [matTooltip]="alarm.summary"
              matTooltipPosition="above"
              matTooltipClass="induxtry-tooltip"
              #summaryTip="matTooltip"
              (mouseenter)="syncCellTooltip($event, summaryTip)">
              {{ alarm.summary }}
            </span>
            <span class="cell-text">{{ alarm.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
        }
      </div>
    </div>
  </div>
}
